import React, { useMemo } from 'react'
import { Select } from '@surecompanies/core_components'
import type {
  VcnActionsSelectProps,
  VcnAction,
} from './VcnPaymentManagement.types'
import { ActionsField, FormLabel } from './VcnPaymentManagement.styles'

interface VcnActionOption {
  id: VcnAction
  name: string
  visible: string | string[]
}

const VCN_ACTIONS: VcnActionOption[] = [
  {
    id: 'terminate',
    name: 'Terminate',
    visible: ['SUSPENDED', 'ACTIVE'],
  },
  {
    id: 'generate',
    name: 'Generate VCN',
    visible: 'TERMINATED',
  },
  {
    id: 'suspend',
    name: 'Suspend',
    visible: 'ACTIVE',
  },
  {
    id: 'reactivate',
    name: 'Reactivate',
    visible: 'SUSPENDED',
  },
]

function getActionsByCardState(cardState: string): VcnActionOption[] {
  const normalizedState = cardState?.toUpperCase() ?? ''
  return VCN_ACTIONS.filter((action) => {
    const conditions = Array.isArray(action.visible)
      ? action.visible
      : [action.visible]
    return conditions.includes(normalizedState)
  }).sort((a, b) => a.name.localeCompare(b.name))
}

export function VcnActionsSelect({
  cardState,
  value,
  onActionSelect,
  disabled = false,
  loading = false,
}: VcnActionsSelectProps) {
  const availableActions = useMemo(
    () => getActionsByCardState(cardState),
    [cardState]
  )

  const options = useMemo(
    () =>
      availableActions.map((action) => ({
        label: action.name,
        value: action.id,
      })),
    [availableActions]
  )

  const handleChange = (val: VcnAction | undefined) => {
    onActionSelect(val)
  }

  if (availableActions.length === 0) {
    return null
  }

  return (
    <ActionsField>
      <FormLabel>Actions</FormLabel>
      <Select
        placeholder="Select"
        value={value}
        options={options}
        onChange={handleChange}
        disabled={disabled || loading}
        loading={loading}
        style={{ width: '100%' }}
        allowClear
      />
    </ActionsField>
  )
}
